import { Component, OnInit } from '@angular/core';
import { FontawesomeListService } from '@scaffold/services/fontawesome-list.service';
import { DataModelService } from '@services/data-model.service';

@Component({
    selector: 'cat-config',
    templateUrl: './cat-config.component.html',
    styleUrls: [
        '../data-model-prefs/data-model-prefs.component.scss',
        './cat-config.component.scss',
    ],
    standalone: false
})
export class CatConfigComponent implements OnInit {
  constructor(
    private dataModelService: DataModelService,
    private icons: FontawesomeListService
  ) {}

  selectedDataCategory;
  selectedCategory;
  selectedIcon;
  previewList = [];
  dataCategories = [];
  iconCategories = [];

  disableSave = false;

  ngOnInit() {
    this.iconCategories = this.icons.catagories;
    this.getCategories();

    this.dataModelService.updateTypeListTrigger().subscribe(() => {
      this.getCategories();
    });
  }

  getCategories() {
    this.dataModelService.getCategories().subscribe(list => {
      this.dataCategories = list;
    });
  }

  getIconHtml(icon) {
    return '<i class="' + icon + '"></i>';
  }

  saveCategory() {
    this.disableSave = true;

    this.dataModelService
      .updateCategory(this.selectedDataCategory.id, {
        json_data: { iconClass: this.selectedIcon },
      })
      .subscribe(data => {
        this.selectedDataCategory = null;
        this.selectedCategory = null;
        this.selectedIcon = null;

        this.disableSave = false;

        this.dataModelService.updateTypes();
      });
  }

  //selectedDataCategory
  previewCat() {
    if (this.selectedDataCategory && this.selectedIcon) {
      this.previewList = [
        {
          label: this.selectedDataCategory.title,
          icon: this.selectedIcon,
          items: [{ label: 'Item 1' }, { label: 'Item 2' }],
        },
      ];
    }
  }
}
